import { StyleSheet, Text, View } from "@react-pdf/renderer"
import React from "react"
import { countCategories } from "../../../../functions/FilterCards"
import { getCategoryLabel } from "../../svg/SvgCanvas/utils/PostitUtils"
import { setOrderLevels } from "../../svg/SvgCanvas/quadrants/utils/evaluationLevel"
import { t } from "i18next"

interface Props {
  cards: ICard[]
  levels: ILevel
  category: string[]
  title: string
}

export const CountEvaluationsLevels: React.FC<Props> = ({ cards, levels, category, title }) => {
  const styles = StyleSheet.create({
    title: {
      fontWeight: "bold",
      marginBottom: 4,
    },
  })

  if (Array.isArray(category)) {
    const counts = countCategories(cards, category)

    const sortedCounts = counts.sort((a, b) => {
      const orderedLevels = setOrderLevels(levels)
      const levelKeys = Object.keys(orderedLevels)
      const indexA = levelKeys.indexOf(a.label)
      const indexB = levelKeys.indexOf(b.label)
      return indexA - indexB
    })

    return (
      <View style={{ marginTop: 10 }}>
        {sortedCounts.map(({ label, count }) => (
          <Text key={label}>
            • {getCategoryLabel(label, levels as ILevel)}: {`${t('feedback.count.votes.has')} ${count} ${count === 1 ? t('feedback.count.votes.vote') : t('feedback.count.votes.votes')}`}
          </Text>
        ))}
      </View>
    )
  }

  return
}
